import { useMemo } from 'react';
import { TaskStatus } from '@sib/api';
import { useTicketsAppTranslation } from '@sib/i18n';
import { Dot } from '@sib/ui/icons';
import { ticketStatusColors } from '../common/tickets/ticket-form.utils';

export const taskStatusColors = ticketStatusColors as Record<
  TaskStatus,
  string
>;

export const useTaskStatusLabel = (): Record<TaskStatus, string> => {
  const { t } = useTicketsAppTranslation();

  return useMemo(
    () => ({
      [TaskStatus.New]: t('enums.ticketStatus.new'),
      [TaskStatus.InProgress]: t('enums.ticketStatus.inProgress'),
      [TaskStatus.Closed]: t('enums.ticketStatus.closed'),
      [TaskStatus.WorkingWithVendor]: t('enums.ticketStatus.workingWithVendor'),
      [TaskStatus.AwaitingClientAction]: t(
        'enums.ticketStatus.awaitingClientAction'
      ),
      [TaskStatus.AwaitingInternalAction]: t(
        'enums.ticketStatus.awaitingInternalAction'
      ),
      [TaskStatus.Canceled]: t('enums.ticketStatus.canceled'),
      [TaskStatus.Completed]: t('enums.ticketStatus.completed'),
    }),
    [t]
  );
};

export const useTaskStatusOptions = () => {
  const { t } = useTicketsAppTranslation();

  return useMemo(
    () => [
      {
        value: TaskStatus.New,
        label: t('enums.ticketStatus.new'),
        color: taskStatusColors[TaskStatus.New],
      },
      {
        value: TaskStatus.InProgress,
        label: t('enums.ticketStatus.inProgress'),
        color: taskStatusColors[TaskStatus.InProgress],
      },
      {
        value: TaskStatus.Closed,
        label: t('enums.ticketStatus.closed'),
        color: taskStatusColors[TaskStatus.Closed],
      },
      {
        value: TaskStatus.WorkingWithVendor,
        label: t('enums.ticketStatus.workingWithVendor'),
        color: taskStatusColors[TaskStatus.WorkingWithVendor],
      },
      {
        value: TaskStatus.AwaitingClientAction,
        label: t('enums.ticketStatus.awaitingClientAction'),
        color: taskStatusColors[TaskStatus.AwaitingClientAction],
      },
      {
        value: TaskStatus.AwaitingInternalAction,
        label: t('enums.ticketStatus.awaitingInternalAction'),
        color: taskStatusColors[TaskStatus.AwaitingInternalAction],
      },
      {
        value: TaskStatus.Canceled,
        label: t('enums.ticketStatus.canceled'),
        color: taskStatusColors[TaskStatus.Canceled],
      },
      {
        value: TaskStatus.Completed,
        label: t('enums.ticketStatus.completed'),
        color: taskStatusColors[TaskStatus.Completed],
      },
    ],
    [t]
  );
};

export const useTaskStatusOptionsWithIcons = () => {
  const taskStatusOptions = useTaskStatusOptions();

  return useMemo(
    () =>
      taskStatusOptions.map(status => ({
        ...status,
        Icon: <Dot style={{ color: status.color }} />,
      })),
    [taskStatusOptions]
  );
};
